const is_open_mixin = {
  data() {
    return {
      open_list: []
    }
  },
  methods: {
    open(m_id,id) {
      let index = this.open_list.indexOf(m_id+id)
      if (index == -1) {
        this.open_list.push(m_id+id)
      } else {
        this.open_list.splice(index, 1)
      }
      setTimeout(() => {
        this.module_item_offset_list = []
        for(let i = 0;i<this.dom_list.length;i++) {
          jQuery(
            this.module_item_offset_list.push({
              id: $(this.dom_list[i]).attr('data-id'),
              offset: $(this.dom_list[i]).offset().top - 250
            })
          )
        }
      }, 2500)
    },
    showOpen(m_id,id) {
      if (this.open_list.indexOf(m_id+id) == -1) {
        return true
      } else {
        return false
      }
    },
    goTopicShare(uid) {
      window.location.href = this.$store.state.index2_path + '/News/newsDetail?uid='+uid
    }
  }
}
export { is_open_mixin }
